import { Component, OnInit } from '@angular/core';
import { LayoutService } from '../layout.service';
import { VERSION } from 'src/environments/version';
import { Store } from '@ngrx/store';
import { selectPatientCardVisible } from '../../_selectors/layout.selectors';
import { ChildrenOutletContexts } from '@angular/router';
import { fadeInAndOutAnimation } from 'app/route-animations';
import { LayoutElementsEnum } from '../../_interface/layoutElements.enum';
import { ClickOutsideService } from 'shared/lib/click-outside/click-outside.service';
import { environment } from 'src/environments/environment';
import { EnvsEnum } from 'src/environments/environment.interface';

@Component({
	selector: 'layout-main',
	templateUrl: './layout.component.html',
	styleUrls: ['./layout.component.scss'],
	animations: [fadeInAndOutAnimation]
})
export class LayoutComponent implements OnInit {
	toolbox$ = this.service.currentToolbox$;
	header$ = this.service.currentHeader$;
	floatingSidebar$ = this.service.currentFloatingSidebar$;
	floatingSidebarToggled$ = this.service.floatingSidebarToggled$;
	bottomBar$ = this.service.currentBottomBar$;
	bottomBarToggled$ = this.service.bottomBarToggled$;
	version = VERSION;
	patientCardVisible$ = this.store.select(selectPatientCardVisible);
	layoutElements = LayoutElementsEnum;

	protected readonly environment = environment;
	protected readonly EnvsEnum = EnvsEnum;

	constructor(
		private service: LayoutService,
		private store: Store,
		private contexts: ChildrenOutletContexts,
		private clickOutsideService: ClickOutsideService
	) { }

	ngOnInit() {}

	getRouteAnimationData() {
		return this.contexts.getContext('primary')?.route?.snapshot?.data?.animation;
	}

	clickOutsideEvent = (element: string) => this.clickOutsideService.manageLayoutElements(element);
}
